module.exports = __webpack_public_path__ + "img/ic_success-yellow.80a5b79e.svg";